export default "__VITE_ASSET__C4eks2$a__"